/* Spanish catalog mirroring locale-fr-part4.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Posible reducción del plazo de crédito',
  'adv.sales.move.chaseSlowPayers.effectNote': 'hasta tu propia media: el efecto en coronas depende de cuándo pague realmente el cliente',
  'adv.sales.move.chaseSlowPayers.action': 'Ver la lista de facturas',
  'adv.sales.move.reviewDiscounts.title': 'Revisar los descuentos',
  'adv.sales.move.reviewDiscounts.text': 'Has concedido {amount} en descuentos este año, de media un {pct} % por factura.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Efecto estimado',
  'adv.sales.move.reviewDiscounts.effectNote': 'reduciendo a la mitad el nivel de descuento',
  'adv.sales.move.reviewDiscounts.action': 'Ver la lista de facturas',
  'adv.sales.move.spreadCustomers.title': 'Diversificar la cartera de clientes',
  'adv.sales.move.spreadCustomers.text': '{name} representa el {pct} % de las ventas. Un solo cliente no debería sostener por sí solo los ingresos.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Peso del mayor cliente',
  'adv.sales.move.spreadCustomers.effectNote': 'es el riesgo, no una ganancia',
  'adv.sales.move.spreadCustomers.action': 'Ver clientes',
  'adv.sales.move.testPriceIncrease.title': 'Valorar una subida de precios',
  'adv.sales.move.testPriceIncrease.text': 'Prueba el efecto de un precio un {pct} % más alto sobre los ingresos antes de decidir.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Efecto anual estimado',
  'adv.sales.move.testPriceIncrease.effectNote': 'con volumen constante',
  'adv.sales.move.testPriceIncrease.action': 'Ver productos',
  'adv.sales.move.growRecurring.title': 'Aumentar las ventas recurrentes',
  'adv.sales.move.growRecurring.text': 'El {pct} % de las ventas es recurrente. Si te acercas al {target} %, los ingresos serán mucho más predecibles.',
  'adv.sales.move.growRecurring.effectLbl': 'Ingresos que pueden volverse predecibles',
  'adv.sales.move.growRecurring.effectNote': 'si la proporción alcanza el objetivo',
  'adv.sales.move.growRecurring.action': 'Ver suscripciones',
  'adv.sales.scn.title': 'Escenarios de ventas: ¿qué pasa si …?',
  'adv.sales.scn.sub': 'Efecto en los ingresos, el resultado y la liquidez',
  'adv.sales.scn.help': 'Elige un escenario para ver el antes y el después en ingresos, resultado, margen y liquidez, junto con los supuestos que he utilizado. Las cifras son cálculos, no garantías.',
  'adv.sales.scn.metric': 'Indicador',
  'adv.sales.scn.base': 'Base',
  'adv.sales.scn.after': 'Tras el escenario',
  'adv.sales.scn.change': 'Variación',
  'adv.sales.scn.row.revenue': 'Ingresos',
  'adv.sales.scn.row.result': 'Resultado',
  'adv.sales.scn.row.margin': 'Margen neto',
  'adv.sales.scn.row.liquidity': 'Saldo previsto calculado',
  'adv.sales.scn.points': '{points} pts',
  'adv.sales.scn.assumptions': 'Supuestos',
  'adv.sales.scn.showAssumptions': 'Mostrar supuestos',
  'adv.sales.scn.confidence': 'Fiabilidad',
  'adv.sales.scn.risk': 'Riesgo',
  'adv.sales.scn.scope': 'Alcance',
  'adv.sales.scn.q.priceUp': 'Subo los precios',
  'adv.sales.scn.q.volumeDown': 'Baja el volumen de ventas',
  'adv.sales.scn.q.halveDiscounts': 'Reduzco los descuentos a la mitad',
  'adv.sales.scn.q.loseTopCustomer': 'Pierdo a {name}',
  'adv.sales.scn.q.growRecurring': 'Las ventas recurrentes aumentan un {pct} %',
  'adv.sales.scn.summary.priceUp': 'Con volumen constante, una subida de precios del {pct} % aporta unos {delta} más de ingresos al año. Una subida de precios no añade costes de mercancía ni de horas, así que todo el importe llega al resultado.',
  'adv.sales.scn.summary.volumeDown': 'Una caída del volumen del {pct} % resta unos {delta} de ingresos. El cálculo supone que los gastos se mantienen estables, por lo que es el escenario más duro: si las compras bajan con el volumen, el impacto será menor.',
  'adv.sales.scn.summary.halveDiscounts': 'Has concedido {amount} en descuentos este año, de media un {pct} %. Si reduces ese nivel a la mitad, recuperas unos {delta}, siempre que los clientes se queden.',
  'adv.sales.scn.summary.loseTopCustomer': 'Si {name} se va, pierdes {delta}, el {pct} % de las ventas. Esta cifra es la razón para diversificar la cartera de clientes antes de que ocurra.',
  'adv.sales.scn.summary.growRecurring': 'Si las ventas recurrentes aumentan un {pct} %, ganas unos {delta} más al año. Los ingresos recurrentes son los más predecibles que tienes.',
  'adv.sales.scn.assumption.priceUp': 'El volumen se mantiene. Se aplica a todos los productos y servicios.',
  'adv.sales.scn.assumption.volumeDown': 'Los gastos se mantienen estables. Plumme no tiene coste de ventas por producto, así que no puedo calcular qué parte de los gastos baja con el volumen.',
  'adv.sales.scn.assumption.halveDiscounts': 'Los clientes compran lo mismo con un descuento menor. Calculado a partir de los descuentos realmente concedidos este año.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Ninguna parte de los ingresos se sustituye por otros clientes. Calculado a partir de las ventas realmente contabilizadas del cliente.',
  'adv.sales.scn.assumption.growRecurring': 'El crecimiento se suma a las ventas actuales, no las sustituye.',
  'adv.sales.scn.riskText.priceUp': 'Si el volumen cae más de lo que sube el precio, el efecto desaparece. Vigila el volumen de ventas durante los dos primeros meses.',
  'adv.sales.scn.riskText.volumeDown': 'Si el volumen baja primero entre los clientes más rentables, el impacto será mayor.',
  'adv.sales.scn.riskText.halveDiscounts': 'Los clientes que compran por el descuento pueden irse. Prueba primero con unos pocos.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Los costes fijos no desaparecen con el cliente, así que el resultado se ve más afectado que los ingresos.',
  'adv.sales.scn.riskText.growRecurring': 'Los contratos recurrentes te comprometen en precio y entrega a largo plazo.',
  'adv.sales.scn.scopeText.all': 'Todos los productos y servicios',
  'adv.sales.scn.scopeText.discounted': 'Solo las facturas con descuento',
  'adv.sales.scn.scopeText.topCustomer': 'Solo el mayor cliente',
  'adv.sales.scn.scopeText.recurring': 'Solo las ventas recurrentes',
  'adv.sales.closerTag': 'Esto es lo que haría yo',
  'adv.tab.tax': 'Impuestos',
  'adv.tab.budget': 'Presupuesto',
  'adv.tab.insight': 'Análisis',
  'adv.plan.title': 'Presupuesto frente a real',
  'adv.plan.sub': '{year}: contabilizado hasta la fecha frente al presupuesto de los primeros {months} meses',
  'adv.plan.help': 'Las cifras contabilizadas corresponden al año en curso, mientras que el presupuesto cubre todo el año. Por eso comparo con el presupuesto hasta el mes actual inclusive; de lo contrario, todo parecería muy por debajo del presupuesto en enero.',
  'adv.plan.tableTitle': 'Desviación por categoría',
  'adv.plan.tableSub': 'Presupuesto de los primeros {months} meses frente a lo contabilizado',
  'adv.plan.tableHelp': 'Las filas están ordenadas por la magnitud de la desviación. También se muestran las cuentas con movimiento que no están presupuestadas, que suelen ser las más interesantes.',
  'adv.plan.col.category': 'Categoría',
  'adv.plan.col.budget': 'Presupuesto a la fecha',
  'adv.plan.col.actual': 'Contabilizado',
  'adv.plan.col.variance': 'Desviación',
  'adv.plan.unbudgeted': 'Sin presupuestar',
  'adv.plan.incomeVariance': 'Desviación de ingresos',
  'adv.plan.costVariance': 'Desviación de gastos',
  'adv.plan.abovePlan': 'por encima del plan',
  'adv.plan.belowPlan': 'por debajo del plan',
  'adv.plan.overPlan': 'por encima del plan',
  'adv.plan.underPlan': 'por debajo del plan',
  'adv.plan.separateNote': 'Las desviaciones de ingresos y de gastos se muestran por separado. Combinadas, una caída de ingresos y un ahorro en gastos podrían compensarse y dar la impresión de que todo va según lo previsto.',
  'adv.plan.noteWorse': '{name} se desvía {amount} en la dirección equivocada tras {months} meses. Conviene revisarlo antes de que la desviación crezca durante el resto del año.',
  'adv.plan.noteBetter': '{name} está {amount} por encima del presupuesto tras {months} meses.',
  'adv.plan.noteUnbudgeted': 'Se han contabilizado {amount} en {name} sin que la cuenta estuviera presupuestada.',
  'adv.plan.editBudget': 'Editar presupuesto',
  'adv.plan.noBudgetTitle': 'No hay presupuesto para este año',
  'adv.plan.noBudgetText': 'Sin presupuesto no tengo con qué comparar las cifras contabilizadas. Si creas uno, mostraré las desviaciones por categoría y te avisaré cuando algo se aleje del plan.',
  'adv.plan.goToBudget': 'Crear presupuesto',
  'adv.plan.notStartedTitle': 'El año aún no ha empezado',
  'adv.plan.notStartedText': 'No hay ningún mes contabilizado en {year} que comparar con el presupuesto.',
  'adv.plan.goalsTitle': 'Objetivos',
  'adv.plan.goalsSub': 'Tus propios objetivos, medidos frente a las cifras contabilizadas',
  'adv.plan.goalsHelp': 'El objetivo se muestra desde el año en que lo creas hasta que lo marques como completado. Un objetivo con la fecha límite vencida sigue visible hasta que lo revises. Los ingresos, el resultado y el margen se miden por ejercicio, mientras que el colchón sigue el saldo.',
  'adv.plan.goalsEmptyTitle': 'No hay objetivos definidos',
  'adv.plan.goalsEmptyText': 'Fija un objetivo con fecha límite, por ejemplo un colchón de liquidez o un margen de beneficio, y seguiré el progreso avisándote si te retrasas.',
  'adv.plan.goalNew': 'Nuevo objetivo',
  'adv.plan.goalEdit': 'Editar objetivo',
  'adv.plan.goalSave': 'Guardar objetivo',
  'adv.plan.goalSaved': 'Objetivo guardado',
  'adv.plan.goalSaveFailed': 'No se pudo guardar el objetivo',
  'adv.plan.goalDeleted': 'Objetivo eliminado',
  'adv.plan.goalTitleLabel': '¿Cuál es el objetivo?',
  'adv.plan.goalTitlePh': 'Ej. Constituir un colchón de liquidez antes de fin de año',
  'adv.plan.goalMetricLabel': '¿Qué debe medirse?',
  'adv.plan.goalMetricHint': 'El valor actual proviene de la contabilidad, no de lo que introduzcas.',
  'adv.plan.goalTargetAmount': 'Valor objetivo (kr)',
  'adv.plan.goalTargetPct': 'Valor objetivo (%)',
  'adv.plan.goalNow': 'Actual',
  'adv.plan.goalTarget': 'Objetivo',
  'adv.plan.goalDeadline': 'Fecha límite',
  'adv.plan.goalDaysLeft': 'Días restantes',
  'adv.plan.goalMeasured': 'Medido frente a: {metric}',
  'adv.plan.goalFromYear': 'Desde {year}',
  'adv.plan.goalReached': 'Alcanzado',
  'adv.plan.goalCompleted': 'Completado',
  'adv.plan.goalNeedsReview': 'Fecha límite vencida: revisa el objetivo',
  'adv.plan.goalComplete': 'Marcar objetivo como completado',
  'adv.plan.goalReopen': 'Reabrir objetivo',
  'adv.plan.goalOverdue': 'La fecha límite ha vencido',
  'adv.plan.goalOnTrack': 'En camino',
  'adv.plan.goalBehind': 'Por detrás del plan',
  'adv.plan.goalTracking': 'En seguimiento',
  'adv.plan.metric.buffer': 'Liquidez a fin de año',
  'adv.plan.metric.income': 'Ingresos contabilizados',
  'adv.plan.metric.result': 'Resultado contabilizado',
  'adv.plan.metric.margin': 'Margen de beneficio',
  'adv.plan.saving': 'Guardando …',
  'adv.plan.eventsTitle': 'Eventos planificados',
  'adv.plan.eventsSub': 'Cobros y pagos conocidos que aún no se han contabilizado',
  'adv.plan.eventsHelp': 'Los eventos se muestran en el año de su fecha. No se trasladan automáticamente al año siguiente; cambia la fecha si el pago se aplaza. Solo los eventos futuros y no contabilizados se incluyen en la previsión de liquidez.',
  'adv.plan.eventsEmptyTitle': 'No hay eventos planificados',
  'adv.plan.eventsEmptyText': 'Sin eventos registrados, la curva de liquidez se mantiene plana después del mes actual, porque solo conoce las cifras contabilizadas.',
  'adv.plan.eventsNote': 'Los eventos de meses anteriores no se tienen en cuenta en la curva. Elimina un evento cuando el pago esté contabilizado para que no se cuente dos veces.',
  'adv.plan.eventNew': 'Nuevo evento',
  'adv.plan.eventEdit': 'Editar evento',
  'adv.plan.eventSave': 'Guardar evento',
  'adv.plan.eventSaved': 'Evento guardado',
  'adv.plan.eventSaveFailed': 'No se pudo guardar el evento',
  'adv.plan.eventDeleted': 'Evento eliminado',
  'adv.plan.eventLabel': '¿De qué se trata?',
  'adv.plan.eventLabelPh': 'Ej. Paga de vacaciones de los empleados',
  'adv.plan.eventKind': 'Tipo',
  'adv.plan.eventDate': 'Fecha',
  'adv.plan.eventDirection': 'Sentido',
  'adv.plan.eventDirectionHint': 'Una salida reduce la liquidez; una entrada la aumenta.',
  'adv.plan.directionOut': 'Salida de la cuenta',
  'adv.plan.directionIn': 'Entrada en la cuenta',
  'adv.plan.eventAmount': 'Importe',
  'adv.plan.kind.salary': 'Salarios y pagas extra',
  'adv.plan.kind.tax': 'Impuestos y tasas',
  'adv.plan.kind.supplier': 'Pago a proveedor',
  'adv.plan.kind.investment': 'Inversión',
  'adv.plan.kind.loan': 'Préstamos y amortizaciones',
  'adv.plan.kind.other': 'Otro',
  'adv.tab.reports': 'Informes',
  'adv.tab.benchmark': 'Comparación',
  'adv.basisCmp.title': 'Base de comparación',
  'adv.basisCmp.sub': 'Con qué se comparan realmente las cifras',
  'adv.basisCmp.help': 'Los indicadores siguientes no se comparan con otras empresas. Dos se miden frente a las cifras propias de la empresa del año anterior y dos frente a un umbral fijo. Cada fila indica de qué caso se trata.',
  'adv.basisCmp.year': 'Ejercicio',
  'adv.basisCmp.against': 'Comparado con',
  'adv.basisCmp.againstValue': 'Cifras propias de {year}',
  'adv.basisCmp.source': 'Fuente de los datos',
  'adv.basisCmp.sourceValue': 'Cifras contabilizadas en Plumme',
  'adv.basisCmp.industry': 'Datos del sector',
  'adv.basisCmp.industryValue': 'No disponibles',
  'adv.basisCmp.row.previousYear': 'frente a {year}',
  'adv.basisCmp.row.threshold': 'frente a umbral fijo',
  'adv.hero.tag': 'El análisis de SuperPlumma este mes',
  'adv.hero.empty': 'El Asesor IA necesita ingresos, gastos y partidas abiertas contabilizados antes de poder dar consejos concretos.',
  'adv.hero.freeCapital': 'Capital disponible',
  'adv.hero.notCalculated': 'no calculado',
  'adv.hero.healthScore': 'Puntuación de salud',
  'adv.hero.waiting': 'en espera',
  'adv.hero.ask': 'Preguntar a SuperPlumma',
  'adv.hero.chatTitle': 'Chatear con SuperPlumma',
  'adv.hero.chatHint': 'Chatea conmigo',
  'adv.hero.briefTag': 'Análisis mensual de SuperPlumma · {year}',
  'adv.hero.healthLead': 'Salud financiera:',
  'adv.hero.greeting.morning': 'Buenos días.',
  'adv.hero.greeting.day': 'Buenas tardes.',
  'adv.hero.greeting.evening': 'Buenas noches.',
  'adv.hero.greetingNamed.morning': 'Buenos días, {name}.',
  'adv.hero.greetingNamed.day': 'Buenas tardes, {name}.',
  'adv.hero.greetingNamed.evening': 'Buenas noches, {name}.',
  'adv.hero.tasksToday': '{count} cosas por hacer hoy',
  'adv.hero.seeAnalysis': 'Ver análisis',
  'adv.hero.effectNote.earlierIn': 'cobrado antes',
  'adv.hero.effectNote.overduePayables': 'vencido con proveedores',
  'adv.hero.effectNote.vatToCover': 'por cubrir',
  'adv.hero.effectNote.vouchersAtRisk': 'compras sin justificante',
  'adv.overnight.title': 'SuperPlumma ha revisado',
  'adv.overnight.transactions': '{count} transacciones analizadas',
  'adv.overnight.vouchers': '{count} justificantes comprobados',
  'adv.overnight.risks': '{count} riesgos evaluados',
  'adv.overnight.recommendations': '{count} recomendaciones encontradas',
  'adv.overnight.updated': 'Última actualización {time}',
  'adv.analysis.title': 'Análisis abierto de IA de la contabilidad',
  'adv.analysis.empty': 'El análisis no está disponible en este momento.',
  'adv.feed.title': 'SuperPlumma ha estado atento',
  'adv.feed.sub': 'Lo que he observado recientemente',
  'adv.feed.help': 'Cambios que he detectado en la contabilidad; no son recomendaciones. El rojo es urgente, el naranja requiere seguimiento y el verde es solo informativo.',
  'adv.feed.seeDetails': 'Ver detalles',
  'adv.feed.marginDown.title': 'El margen de beneficio ha bajado {points} puntos porcentuales',
  'adv.feed.marginDown.body': 'En comparación con el año pasado. Conviene mirarlo con más detalle antes de que se convierta en tendencia.',
  'adv.feed.marginUp.title': 'El margen de beneficio ha subido {points} puntos porcentuales',
  'adv.feed.marginUp.body': 'En comparación con el año pasado. No hace falta hacer nada; es solo para que lo sepas.',
  'adv.feed.costLineJump.title': '{name} ha aumentado un {pct} %',
  'adv.feed.costLineJump.body': 'Esta partida de gasto crece más rápido que las demás en comparación con el año pasado.',
  'adv.feed.overdueSales.title': '{amount} en cuentas por cobrar están vencidos',
  'adv.feed.overdueSales.body': 'El dinero ya está ganado; solo falta cobrarlo.',
  'adv.feed.overduePurchases.title': '{amount} en cuentas por pagar están vencidos',
  'adv.feed.overduePurchases.body': 'Las cuentas por pagar vencidas pueden generar intereses de demora y gastos de reclamación.',
  'adv.feed.concentration.title': 'Un cliente representa el {pct} % de las ventas',
  'adv.feed.concentration.body': 'Una fuerte dependencia de un cliente hace vulnerables los ingresos si ese cliente se va.',
  'adv.feed.costsDown.title': 'Los gastos han bajado un {pct} % respecto al año pasado',
  'adv.feed.costsDown.body': 'No hace falta hacer nada; es solo para que lo sepas.',
  'adv.feed.incomeUp.title': 'Los ingresos han aumentado un {pct} % respecto al año pasado',
  'adv.feed.incomeUp.body': 'El crecimiento se calcula a partir de los ingresos contabilizados en el mismo periodo.',
  'adv.feed.vouchersComplete.title': 'Todas las compras tienen justificante',
  'adv.feed.vouchersComplete.body': 'Por ahora no hay nada aquí que requiera tu atención.',
  'adv.employees.title': 'Empleados y nómina',
  'adv.employees.help': 'Este módulo solo se muestra porque la empresa tiene empleados o procesos de nómina. Las cifras provienen de los gastos de personal contabilizados y de tus procesos de nómina.',
  'adv.employees.count': 'Empleados',
  'adv.employees.share': 'Gastos de personal / ingresos',
  'adv.employees.cost': 'Gastos de personal contabilizados',
  'adv.employees.runs': 'Procesos de nómina este año',
  'adv.employees.note': 'La proporción salarial se calcula a partir de las cuentas contabilizadas de la serie 5000 en relación con los ingresos del año.',
  'adv.employees.go': 'Ver nómina',
  'adv.taskcenter.title': 'Mis tareas de SuperPlumma',
  'adv.taskcenter.all': 'Todas',
  'adv.taskcenter.empty': 'No hay tareas en esta categoría.',
  'adv.status.bucket.now': 'Requiere acción ahora',
  'adv.profile.title': 'Perfil de asesoramiento',
  'adv.profile.help': 'Todo lo que SuperPlumma sabe sobre cómo quieres recibir asesoramiento (colchón, objetivo, nivel de riesgo y frecuencia) reunido en un solo lugar. Puedes cambiarlo todo aquí.',
  'adv.profile.intro': 'Uso esta información para que mis consejos sean más relevantes. Cambiar algo aquí modifica cómo priorizo, no cómo se lleva la contabilidad.',
  'adv.profile.buffer': 'Colchón deseado',
  'adv.profile.mainGoal': 'Objetivo principal',
  'adv.profile.mainGoal.revenue': 'Aumentar los ingresos',
  'adv.profile.mainGoal.profitability': 'Mejorar la rentabilidad',
  'adv.profile.mainGoal.buffer': 'Constituir un colchón de liquidez',
  'adv.profile.mainGoal.hiring': 'Contratar',
  'adv.profile.mainGoal.investment': 'Invertir',
  'adv.profile.mainGoal.workload': 'Reducir la carga de trabajo',
  'adv.profile.mainGoal.dividend': 'Preparar la empresa para repartir dividendos',
  'adv.profile.risk': 'Nivel de riesgo preferido',
  'adv.profile.risk.cautious': 'Seguro y prudente',
  'adv.profile.risk.balanced': 'Equilibrado',
  'adv.profile.risk.offensive': 'Abierto al riesgo',
  'adv.profile.cadence': 'Frecuencia deseada de los consejos',
  'adv.profile.cadence.daily': 'Diaria',
  'adv.profile.cadence.weekly': 'Semanal',
  'adv.profile.cadence.monthly': 'Mensual',
  'adv.profile.accountantInvolved': 'Involucrar al contable en las propuestas que requieren una valoración',
  'adv.profile.investments': 'Eventos planificados',
  'adv.profile.noInvestments': 'Ninguno registrado',
  'adv.profile.season': 'Estacionalidad',
  'adv.profile.seasonText': 'Meses fuertes: {strong}. Meses flojos: {weak}.',
  'adv.profile.noSeason': 'Todavía hay muy pocos asientos para identificar una tendencia.',
  'adv.profile.learned': 'Lo que he aprendido de tus decisiones',
  'adv.profile.nothingLearned': 'Todavía no he aprendido nada.',
  'adv.profile.saveFailed': 'No se pudo guardar el perfil de asesoramiento',
  'adv.buffer.recommended': 'Colchón recomendado',
  'adv.buffer.chosen': 'Colchón elegido',
  'adv.buffer.edit': 'Ajustar el colchón de liquidez',
  'adv.buffer.editAria': 'Ajustar el colchón de liquidez de {amount}',
  'adv.buffer.title': 'Colchón de liquidez',
  'adv.buffer.auto': 'Recomendación automática',
  'adv.buffer.autoHelp': 'SuperPlumma utiliza la mayor necesidad calculada. La recomendación actual es {amount}.',
  'adv.buffer.custom': 'Importe personalizado',
  'adv.buffer.customHelp': 'Usar este importe como umbral fijo para consejos, riesgos y liquidez.',
  'adv.buffer.amount': 'Colchón deseado en coronas',
  'adv.buffer.basisTitle': 'Base de la recomendación automática',
  'adv.buffer.basisMinimum': 'Nivel mínimo',
  'adv.buffer.basisMonthlyCosts': 'Un mes de gastos',
  'adv.buffer.basisTax': 'Reserva fiscal calculada',
  'adv.buffer.basisVat': 'IVA por pagar',
  'adv.buffer.basisHelp': 'El colchón automático utiliza el mayor de estos importes. Es un umbral de control, no dinero depositado en una cuenta aparte.',
  'adv.buffer.saving': 'Guardando …',
  'adv.buffer.saved': 'Colchón de liquidez guardado',
  'adv.buffer.invalid': 'Introduce un importe superior a 0 kr.',
  'adv.buffer.unavailable': 'El ajuste del colchón no está disponible en este momento.',
  'adv.buffer.saveFailed': 'No se pudo guardar el colchón de liquidez.',
  'adv.generated.kicker': 'Análisis abierto de IA de la contabilidad',
  'adv.generated.daily': 'Consejo del día',
  'adv.generated.monthly': 'Este mes',
  'adv.generated.previousMonthly': 'Mes anterior',
  'adv.generated.loading': 'SuperPlumma está leyendo los datos de asesoramiento actualizados …',
  'adv.generated.updated': 'Actualizado {date}',
  'adv.generated.topOpportunity': 'Tu mayor potencial',
  'adv.generated.changes': '¿Qué está pasando ahora?',
  'adv.generated.actions': 'Lo que haría ahora',
  'adv.generated.opportunities': 'Oportunidades',
  'adv.generated.taxChecks': 'Impuestos e IVA: puntos de control',
  'adv.generated.more': 'Ver más oportunidades y puntos de control',
  'adv.generated.nextStep': 'Siguiente paso',
  'adv.generated.readOnly': 'El análisis es solo orientativo y no realiza ninguna acción.',
  'adv.generated.importCoverage': 'Basado en los totales importados y los saldos de las cuentas de terceros. El control de asientos individuales y de la integridad de los justificantes es limitado.',
  'adv.generated.refresh': 'Actualizar consejos',
  'adv.generated.failed': 'No se pudo actualizar el consejo de IA en este momento.',
  'adv.generated.unavailable': 'Todavía no hay ningún consejo de IA listo',
  'adv.generated.empty': 'Todavía no hay ningún consejo finalizado que mostrar. Prueba a actualizar los consejos.',
  'adv.generated.limitReached': 'Se ha alcanzado el límite mensual de nuevos consejos de IA. Los consejos existentes siguen disponibles y el límite se restablecerá el próximo mes.',
  'adv.generated.todayCurrent': 'El consejo del día está listo',
  'adv.generated.monthCurrent': 'El consejo del mes se ha actualizado hoy',
  'adv.generated.previousMonthCurrent': 'La retrospectiva se ha actualizado hoy',
  'adv.generated.noDataChanges': 'No hay datos nuevos',
  'adv.generated.monthCooldown': 'Actualización semanal',
  'adv.generated.todayAlreadyCurrent': 'El consejo del día ya está disponible. Recibirás un nuevo consejo del día a partir de mañana.',
  'adv.generated.monthAlreadyCurrent': 'El consejo del mes se ha actualizado hoy. Podrá actualizarse mañana si cambian los datos contables.',
  'adv.generated.previousMonthAlreadyCurrent': 'La retrospectiva se ha actualizado hoy. Podrá actualizarse mañana si se contabilizan datos nuevos en el periodo.',
  'adv.generated.noDataChangesInfo': 'No hay datos contables nuevos desde el último consejo. No se ha utilizado ninguna llamada a la IA.',
  'adv.generated.monthCooldownInfo': 'El consejo mensual puede actualizarse una vez por semana cuando ha cambiado la base contable.',
  'adv.generated.previousKept': 'Se mantiene visible el consejo anterior.',
  'adv.generated.type.booked': 'Hecho contabilizado',
  'adv.generated.type.calculated': 'Calculado',
  'adv.generated.type.scenario': 'Escenario',
  'adv.generated.type.opportunity': 'Oportunidad',
  'adv.generated.type.control': 'Punto de control',
  'adv.generated.confidence.high': 'Base sólida',
  'adv.generated.confidence.medium': 'Base media',
  'adv.generated.confidence.low': 'Base limitada',
  'adv.health.title': 'Puntuación de salud financiera',
  'adv.health.sub': 'Valoración global de la situación financiera de la empresa',
  'adv.health.help': 'La puntuación global solo se muestra cuando se pueden calcular los cuatro indicadores. Los valores desconocidos no suman puntos. Consulta la base de datos para ver qué falta.',
  'adv.health.badge.good': 'Sana',
  'adv.health.badge.stable': 'Estable',
  'adv.health.badge.weak': 'Frágil',
  'adv.health.badge.none': 'Datos insuficientes',
  'adv.health.word.good': 'Buena salud financiera',
  'adv.health.word.stable': 'Finanzas estables',
  'adv.health.word.weak': 'Requiere seguimiento',
  'adv.health.word.none': 'Valoración provisional',
  'adv.health.emptyTitle': 'Datos insuficientes para una puntuación de salud',
  'adv.health.emptyText': 'Contabiliza ventas, compras y partidas abiertas para activar el análisis.',
  'adv.health.summaryFallback': 'SuperPlumma evalúa la liquidez, el crecimiento, la rentabilidad y la estabilidad a partir de tu contabilidad.',
  'vat.wordMva': 'IVA',
  'vat.wordMoms': 'IVA',
  'vat.exemptMva': 'Exento de IVA',
  'vat.exemptMoms': 'Exento de IVA',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'exento',
  'vat.zeroRatedSuffixMoms': 'exento',
  'vat.salesReverseCharge51': '51 - Inversión del sujeto pasivo en ventas',
  'vat.export52': '52 - Exportación',
  'adv.health.category.likviditet': 'Liquidez',
  'adv.health.category.vekst': 'Crecimiento',
  'adv.health.category.lonnsomhet': 'Rentabilidad',
  'adv.health.category.stabilitet': 'Estabilidad',
  'adv.health.note.noOpenPayables': 'No hay cuentas por pagar abiertas registradas',
  'adv.health.note.noDebt': 'Sin deudas',
  'adv.health.note.unknown': 'Desconocido',
  'adv.health.note.receivablesVsPayables': 'Cuentas por cobrar en relación con las cuentas por pagar abiertas',
  'adv.health.note.zeroPrevYearRevenue': 'Los ingresos del año pasado son 0; no se puede calcular el crecimiento porcentual',
  'adv.health.note.needsPrevYear': 'Se necesitan las cifras del año pasado para la comparación',
  'adv.health.note.revenueChangeVsPrevYear': 'Variación de los ingresos respecto al mismo periodo del año pasado',
  'adv.health.note.marginFromReport': 'Margen de resultado según la cuenta de resultados',
  'adv.health.note.noBookedRevenue': 'No hay ingresos contabilizados para el año seleccionado',
  'adv.health.note.largestCustomerShare': 'Parte de las ventas correspondiente al mayor cliente',
  'adv.health.note.needsInvoicesPerCustomer': 'Se necesitan las ventas facturadas por cliente',
  'adv.help.healthCard': 'La puntuación de salud es un total sencillo de 0 a 100. Tiene en cuenta varios aspectos a la vez, como la liquidez, los ingresos, los gastos y los riesgos. Es una referencia, no un veredicto.',
  'adv.help.liquidity': 'Este importe son las cuentas por cobrar abiertas menos las cuentas por pagar abiertas. No indica cuánto dinero hay en la cuenta bancaria.',
  'adv.help.expectedBalance': 'Saldo previsto calculado al final del periodo. Las cifras no se basan en un saldo bancario conciliado ni en fechas de pago seguras.',
  'adv.help.expectedIn': 'Ingresos contabilizados en la ventana mostrada, no cobros confirmados.',
  'adv.help.expectedOut': 'Gastos contabilizados en la ventana mostrada, no pagos confirmados.',
  'adv.help.cashBalance': 'El saldo es el dinero disponible en este momento según este cálculo.',
  'adv.help.bookedIn': 'Las entradas contabilizadas son los ingresos o cobros ya registrados en la contabilidad para el periodo.',
  'adv.help.bookedOut': 'Las salidas contabilizadas son los gastos o pagos ya registrados en la contabilidad para el periodo.',
  'adv.help.endBalance': 'El saldo final es el saldo de hoy más las entradas menos las salidas. Muestra dónde acaba la liquidez según este cálculo.',
  'adv.help.buffer': 'El colchón de liquidez es un umbral de seguridad deseado. No es una cuenta aparte, sino un importe que Plumme usa para avisarte cuando la liquidez se queda demasiado baja.',
  'adv.help.bufferMinimum': 'El nivel mínimo es el colchón más bajo que recomienda Plumme. Evita que la recomendación sea demasiado baja cuando la empresa tiene poco historial.',
  'adv.help.monthlyCosts': 'Un mes de gastos es aproximadamente lo que la empresa suele gastar en un mes. Te ayuda a superar un mes difícil.',
  'adv.help.taxReserve': 'La reserva fiscal es el dinero que deberías apartar para los impuestos, para que la factura fiscal no sea una sorpresa.',
  'adv.help.vatDue': 'El IVA por pagar es el impuesto sobre el valor añadido que probablemente habrá que abonar en el próximo vencimiento del IVA.',
});
